import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IonRouterOutlet, ModalController, PopoverController } from '@ionic/angular';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { MenuComponent } from './menu/menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
@Input() Titulo: string = "Leonardo DaVinci"
@Input() Menu:boolean=true;
@Input() Back: boolean = true;
@Input() defaultHref = "home"
@Input() Mensaje = ""
@Output() Accion = new EventEmitter();
@Input() TextoAccion = "Aceptar"
@Input() Text = ""



OcultarMenu = false;

Foto = ""
Nombre = ""
Ambiente = ""
  constructor(public popoverController: PopoverController, public utilidades: UtilidadesService) { }

  ngOnInit() {
    this.CargarNombreYFoto()
    let host = location.hostname
    if (host == "localhost" || host == "192.168.0.78") {
      this.Ambiente = "Ambiente --> Local"
    } else if (host == "testapp.leonardo-da-vinci.edu.do") {
      this.Ambiente = "Ambiente --> Pruebas"
    } else {
      this.Ambiente = ""
    }
  }

  hayTareasPendientes(){
    let info:any = localStorage.getItem(btoa("TareasAutomaticas"))

    if(info){
      info = JSON.parse(atob(info))
      if(info.length>0){
        return true
      }
    }

    return false
  }

  CargarNombreYFoto(){
    this.Foto = atob(localStorage.getItem(btoa("Foto")))
    this.Nombre = atob(localStorage.getItem(btoa("Nombres")))

    setTimeout(() => {
      this.CargarNombreYFoto()
    }, 3000);
  }

  Hacer(){
    this.Accion.emit(1)
  }

  OcultarMostrarMenu(){
    this.OcultarMenu = !this.OcultarMenu
    this.utilidades.nextocultarMenu(this.OcultarMenu)
  }

  async Menucito(ev: any) {
    const popover = await this.popoverController.create({
      component: MenuComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true,
      "dismissOnSelect":true
    });
    await popover.present();
  
    const { role } = await popover.onDidDismiss();
  }

}
